/* Copyright 2018 The MathWorks, Inc. */

/**
 * The toolstrip can be in one of 2 display modes: DEFAULT or COMPACT.
 */

define([], function () {
    return {
        DEFAULT: "default",
        COMPACT: "compact"
    };
});